import React, { useEffect, useState } from "react";
import "./refundDialog.css";
import "./orderDetails2.css";
import "../../analytics/analytics.css";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Button,
  Divider,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { v4 as uuidv4 } from "uuid";
import CustomButton from "../../../reusableComponents/CustomButton";
import CustomDropdown from "../../../reusableComponents/CustomDropdown";
import { useAuth } from "../../../context/API_Client";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
export default function RefundDialog(props) {
  const {
    gridData,
    paymentMethodData,
    toggleDialog,
    updateToggleDialog,
    val,
    remainingAmount,
    initiateVoidCaptureRefund,
    initiateVoidCaptureRefundError,
    updateInitiateVoidCaptureRefundError,
    reasonsToDisplay,
    reasonsToSend,
    isAuthorizedPermission,
    merchantSetting
  } = props;
  const [amount, setAmount] = useState(0);
  const [err, setError] = useState("");
  const [otherReasonValue, setOtherReasonValue] = useState("");
  const [reason, setReason] = useState();
  const [uuid, setUuid] = useState(uuidv4());
  const [methodInfo, setMethodInfo] = useState();

  const IS_AGENT = merchantSetting?.refundReviewEnabled && !isAuthorizedPermission("REFUND_REVIEW_PAYMENT")
  const SUBMIT_BUTTON_TEXT = IS_AGENT ? "Raise Request" : "Submit"

  useEffect(() => {
    setMethodInfo(
      paymentMethodData?.find(
        (obj) =>
          obj?.brand === gridData["basicDetails.emiMethod.brand"] ||
          obj?.brand === gridData["basicDetails.paymentMethod.brand"]
      )
    );
  }, []);

  // useState(() => {
  //   if (reasonsToSend?.length > 0) {
  //     setReason(reasonsToSend[0]);
  //   }
  // });

  const handleCancel = () => {
    setReason(reasonsToSend[0]);
    setAmount(0);
    updateToggleDialog(false, val);
    updateInitiateVoidCaptureRefundError("");
  };

  const handleClick = () => {
    const id =
      val === "Refund"
        ? "refunds"
        : val === "Capture"
          ? "captures"
          : "cancellations";
    initiateVoidCaptureRefund(
      {
        money: {
          amount: amount,
          currencyCode: gridData["authorisation.money.currencyCode"],
        },
        shopper: {
          email: gridData["basicDetails.shopper.email"],
        },
        refundReason: reason,
        customRefundReason: otherReasonValue,
      },
      id,
      val,
      uuidv4(),
      IS_AGENT
    );
    setAmount(0);
    setReason(reasonsToSend[0]);
  };

  const handleChange = (e) => {
    setError("");
    updateInitiateVoidCaptureRefundError("");
    const re = /^[0-9][\.\d]*(,\d+)?$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setAmount(e.target.value);
      if (e.target.val === "") {
        setError("");
      } else if (parseFloat(e.target.value) <= 0) {
        setError(`${val} amount cannot be Zero or Empty`);
      } else if (parseFloat(e.target.value) > parseFloat(remainingAmount)) {
        setError(`${val} amount cannot exceed remaining amount`);
      } else {
        setError("");
      }
    }
  };



  useEffect(() => {
    if (reasonsToSend?.length && reasonsToSend[0]) {
      setReason(reasonsToSend[0])
    }
  }, [reasonsToSend])

  if (val === "Void") {
    return (
      <Dialog
        open={toggleDialog}
        PaperProps={{
          style: {
            backgroundColor: "#FFF",
            borderRadius: "12px",
            width: "416px",
            justifyContent: "space-between",
          },
        }}
      >
        <div className="void-card">
          <div className="void-img">
            <img src="/assets/orderDetailsIcons/ExclamationCircle-yellow.svg" />
          </div>
          <div>
            <Typography
              className="bodyB1Medium"
              sx={{
                color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
                marginBottom: "8px",
              }}
            >
              Info
            </Typography>
            <Typography
              className="bodyB2RegularText"
              sx={{ color: "var(--text-medium, rgba(1, 1, 2, 0.60))" }}
            >
              Clicking 'Void' cancels the transaction permanently. Verify
              details before confirming, as this action is irreversible.
            </Typography>
            {initiateVoidCaptureRefundError ? (
              <div className="error">
                <img src="/assets/errorOutline.svg" />
                <Typography
                  className="labelRegular"
                  style={{
                    color: "var(--comms-negative, #B9232F)",
                    padding: "0px 0px 6px 0px",
                  }}
                >
                  {initiateVoidCaptureRefundError}
                </Typography>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <DialogActions className="card-footer">
          <Button
            sx={{ "&:hover": { backgroundColor: "var(--neutral-1, #FFF)" } }}
            variant="contained"
            disableRipple
            disableElevation
            className="btn cancel-btn"
            onClick={handleCancel}
          >
            <Typography className="bodyB2MediumColored">Cancel</Typography>
          </Button>
          <Button
            sx={{
              "&:hover": { backgroundColor: "var(--generic-primary, #24B7AA)" },
            }}
            variant="contained"
            disableRipple
            disableElevation
            className="btn refund-btn"
            disabled={err == "" ? false : true}
            onClick={handleClick}
          >
            <Typography className="bodyB2Medium" style={{ color: "white" }}>
              Confirm
            </Typography>
          </Button>
        </DialogActions>
      </Dialog>
    );
  } else {
    return (
      <Dialog
        open={toggleDialog}
        PaperProps={{
          style: {
            backgroundColor: "#FFF",
            borderRadius: "12px",
            width: "640px",
            minHeight: "433px",
            display: "flex",
            justifyContent: "space-between",
          },
        }}
      >
        <div style={{ padding: "24px" }}>
          {" "}
          <div className="card-header">
            <div className="card-header-content">
              <div className="card-header-content-top">
                <Typography className="SemiboldTwenty">
                  {val === "Refund" ? "Create Refund" : "Capture Amount"}
                </Typography>
                <CloseIcon
                  sx={{ width: "24px", height: "36px" }}
                  className="icon"
                  onClick={() => updateToggleDialog(false, val)}
                />
              </div>
              {val === "Refund" ? (
                <Typography className="refund-info">
                  Refunds take 5-10 business days to appear on your customer’s
                  bank statement. Please note that your processor will not
                  return the original MDR charged on this transaction.
                </Typography>
              ) : (
                <Typography className="refund-info">
                  Capture becomes successful once the PSP approves it. We will
                  keep you updated.
                </Typography>
              )}
            </div>
          </div>
          <DialogContent className="card-content">
            <div>
              <Divider />
            </div>

            <div className="refund-transaction-details">
              {gridData["basicDetails.context.orderId"] && (
                <div style={{ paddingRight: "60px" }}>
                  <Typography className="labelSemiBoldColored">
                    Order ID
                  </Typography>
                  <Typography
                    className="bodyB2SemiBoldColored"
                    sx={{ paddingTop: "8px" }}
                  >
                    {gridData["basicDetails.context.orderId"]}
                  </Typography>
                </div>
              )}
              {gridData["basicDetails.transactionId"] && (
                <div style={{ paddingRight: "60px" }}>
                  <Typography className="labelSemiBoldColored">
                    Transaction ID
                  </Typography>
                  <Typography
                    className="bodyB2SemiBoldColored"
                    sx={{ paddingTop: "8px" }}
                  >
                    {gridData["basicDetails.transactionId"]}
                  </Typography>
                </div>
              )}
              {methodInfo && (
                <div>
                  <Typography className="labelSemiBoldColored">
                    Method
                  </Typography>
                  <div className="brand-logo-typography">
                    {methodInfo?.logoUrl && (
                      <div className="payment-logo">
                        <img src={methodInfo?.logoUrl} />
                      </div>
                    )}
                    <Typography
                      className="bodyB2SemiBoldColored"
                      sx={{ paddingTop: "8px" }}
                    >
                      {methodInfo?.title}
                    </Typography>
                  </div>
                </div>
              )}
            </div>

            <div className="refund-capture-initiation">
              <div className="input">
                <Typography className="bodyB2RegularText">{`${val}:`}</Typography>
                <div
                  style={{
                    display: "flex",
                    paddingTop: "10px",
                    paddingBottom: "6px",
                  }}
                >
                  <input onChange={handleChange} name="amount" value={amount} />
                  <div className="country-code">
                    <Typography className="bodyB2RegularText">
                      {gridData["authorisation.money.currencyCode"]}
                    </Typography>
                  </div>
                </div>
                {err != "" ? (
                  <div className="error">
                    <img src="/assets/errorOutline.svg" />
                    <Typography
                      className="labelRegular"
                      style={{
                        color: "var(--comms-negative, #B9232F)",
                        padding: "0px 0px 6px 0px",
                      }}
                    >
                      {err}
                    </Typography>
                  </div>
                ) : (
                  <></>
                )}
                {err == "" && initiateVoidCaptureRefundError ? (
                  <div className="error">
                    <img src="/assets/errorOutline.svg" />
                    <Typography
                      className="labelRegular"
                      style={{
                        color: "var(--comms-negative, #B9232F)",
                        padding: "0px 0px 6px 0px",
                      }}
                    >
                      {initiateVoidCaptureRefundError}
                    </Typography>
                  </div>
                ) : (
                  <></>
                )}
                <Typography className="labelRegular">{`${gridData["authorisation.money.currencyCode"]} ${remainingAmount} remaining`}</Typography>
              </div>
              <div>
                {val === "Refund" ? (
                  <>
                    <Typography className="bodyB2RegularText">
                      Reason:{" "}
                    </Typography>
                    <div style={{ display: "flex", paddingTop: "10px" }}>
                      {reasonsToDisplay && reasonsToDisplay && (
                        <CustomDropdown
                          width={"230px"}
                          height={"32px"}
                          fontSize={"14px"}
                          optionsToSend={reasonsToSend}
                          optionsToDisplay={reasonsToDisplay}
                          updateSelect={(id, value) => setReason(value)}
                          dropDownId={"Refund"}
                          defaultValue={reasonsToDisplay[0]}
                        />
                      )}
                    </div>
                    {reason === "others" && (
                      <div className="otherReasonField">
                        <TextField
                          variant="outlined"
                          placeholder="Other Reason"
                          id="outlined-basic"
                          size="small"
                          onChange={(e) => setOtherReasonValue(e.target.value)}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </DialogContent>
        </div>

        <DialogActions className="card-footer" sx={{ padding: "0px" }}>
          <CustomButton
            text={"Cancel"}
            onClick={handleCancel}
            variant={"outlined"}
            type={"secondary"}
          ></CustomButton>
          <CustomButton
            text={SUBMIT_BUTTON_TEXT}
            variant={"contained"}
            type={"secondary"}
            disabled={
              err !== "" ||
              isNaN(parseFloat(amount)) ||
              parseFloat(amount) <= 0 ||
              parseFloat(amount) > parseFloat(remainingAmount) ||
              (reason === "others" && otherReasonValue === "") ||
              (reason !== "others" && parseFloat(amount) === 0)
            }
            onClick={handleClick}
          ></CustomButton>
        </DialogActions>
      </Dialog>
    );
  }
}
